module.exports = __webpack_public_path__ + "img/success.6db2e831.png";